module.exports = __webpack_public_path__ + "img/checo2.d0c06cf9.jpg";